module.exports = __webpack_public_path__ + "img/3.7bf9bb78.png";